import { createStore } from 'vuex';
import { auth } from './auth.module';
import { warehouse } from "@/store/warehouse.module";
import { alert } from "@/store/alert.module";
import { reports } from "@/store/reports.module";
import { user } from "@/store/user.module";
import { resource } from "@/store/resource.module";

const store = createStore({
    modules: {
        auth,
        warehouse,
        alert,
        reports,
        user,
        resource
    }
})

export default store;